
export interface Region {
  code: string;
  name: string;
  country: string;
}

export const regions: Region[] = [
  // 台灣縣市
  { code: 'TPE', name: '台北市', country: 'TW' },
  { code: 'NTC', name: '新北市', country: 'TW' },
  { code: 'TYC', name: '桃園市', country: 'TW' },
  { code: 'TXG', name: '台中市', country: 'TW' },
  { code: 'TNN', name: '台南市', country: 'TW' },
  { code: 'KHH', name: '高雄市', country: 'TW' },
  { code: 'HSZ', name: '新竹市', country: 'TW' },
  { code: 'HSQ', name: '新竹縣', country: 'TW' },
  { code: 'MIA', name: '苗栗縣', country: 'TW' },
  { code: 'CHA', name: '彰化縣', country: 'TW' },
  { code: 'NAN', name: '南投縣', country: 'TW' },
  { code: 'YUN', name: '雲林縣', country: 'TW' },
  { code: 'CYI', name: '嘉義市', country: 'TW' },
  { code: 'CYQ', name: '嘉義縣', country: 'TW' },
  { code: 'PIF', name: '屏東縣', country: 'TW' },
  { code: 'ILA', name: '宜蘭縣', country: 'TW' },
  { code: 'HUA', name: '花蓮縣', country: 'TW' },
  { code: 'TTT', name: '台東縣', country: 'TW' },
  { code: 'PEH', name: '澎湖縣', country: 'TW' },
  { code: 'KIN', name: '金門縣', country: 'TW' },
  { code: 'LIE', name: '連江縣', country: 'TW' },
  
  // 中國省份
  { code: 'BJ', name: '北京市', country: 'CN' },
  { code: 'SH', name: '上海市', country: 'CN' },
  { code: 'TJ', name: '天津市', country: 'CN' },
  { code: 'CQ', name: '重慶市', country: 'CN' },
  { code: 'HE', name: '河北省', country: 'CN' },
  { code: 'SX', name: '山西省', country: 'CN' },
  { code: 'LN', name: '遼寧省', country: 'CN' },
  { code: 'JL', name: '吉林省', country: 'CN' },
  { code: 'HL', name: '黑龍江省', country: 'CN' },
  { code: 'JS', name: '江蘇省', country: 'CN' },
  { code: 'ZJ', name: '浙江省', country: 'CN' },
  { code: 'AH', name: '安徽省', country: 'CN' },
  { code: 'FJ', name: '福建省', country: 'CN' },
  { code: 'JX', name: '江西省', country: 'CN' },
  { code: 'SD', name: '山東省', country: 'CN' },
  { code: 'HA', name: '河南省', country: 'CN' },
  { code: 'HB', name: '湖北省', country: 'CN' },
  { code: 'HN', name: '湖南省', country: 'CN' },
  { code: 'GD', name: '廣東省', country: 'CN' },
  { code: 'HI', name: '海南省', country: 'CN' },
  { code: 'SC', name: '四川省', country: 'CN' },
  { code: 'GZ', name: '貴州省', country: 'CN' },
  { code: 'YN', name: '雲南省', country: 'CN' },
  { code: 'SN', name: '陝西省', country: 'CN' },
  { code: 'GS', name: '甘肅省', country: 'CN' },
  { code: 'QH', name: '青海省', country: 'CN' },
  { code: 'NM', name: '內蒙古自治區', country: 'CN' },
  { code: 'GX', name: '廣西壯族自治區', country: 'CN' },
  { code: 'XZ', name: '西藏自治區', country: 'CN' },
  { code: 'NX', name: '寧夏回族自治區', country: 'CN' },
  { code: 'XJ', name: '新疆維吾爾自治區', country: 'CN' },
  
  // 香港特別行政區
  { code: 'HK-HKI', name: '香港島', country: 'HK' },
  { code: 'HK-KLN', name: '九龍', country: 'HK' },
  { code: 'HK-NT', name: '新界', country: 'HK' },
  
  // 澳門特別行政區
  { code: 'MO-MP', name: '澳門半島', country: 'MO' },
  { code: 'MO-TI', name: '氹仔', country: 'MO' },
  { code: 'MO-CO', name: '路環', country: 'MO' },
  
  // 日本都道府縣
  { code: 'JP-13', name: '東京都', country: 'JP' },
  { code: 'JP-14', name: '神奈川縣', country: 'JP' },
  { code: 'JP-27', name: '大阪府', country: 'JP' },
  { code: 'JP-01', name: '北海道', country: 'JP' },
  { code: 'JP-23', name: '愛知縣', country: 'JP' },
  { code: 'JP-26', name: '京都府', country: 'JP' },
  { code: 'JP-28', name: '兵庫縣', country: 'JP' },
  { code: 'JP-40', name: '福岡縣', country: 'JP' },
  { code: 'JP-04', name: '宮城縣', country: 'JP' },
  { code: 'JP-12', name: '千葉縣', country: 'JP' },
  
  // 韓國行政區
  { code: 'KR-11', name: '首爾特別市', country: 'KR' },
  { code: 'KR-26', name: '釜山廣域市', country: 'KR' },
  { code: 'KR-27', name: '大邱廣域市', country: 'KR' },
  { code: 'KR-28', name: '仁川廣域市', country: 'KR' },
  { code: 'KR-29', name: '光州廣域市', country: 'KR' },
  { code: 'KR-30', name: '大田廣域市', country: 'KR' },
  { code: 'KR-31', name: '蔚山廣域市', country: 'KR' },
  { code: 'KR-41', name: '京畿道', country: 'KR' },
  { code: 'KR-42', name: '江原道', country: 'KR' },
  { code: 'KR-43', name: '忠清北道', country: 'KR' },
  
  // 新加坡行政區
  { code: 'SG-CS', name: '中區', country: 'SG' },
  { code: 'SG-ES', name: '東區', country: 'SG' },
  { code: 'SG-WS', name: '西區', country: 'SG' },
  { code: 'SG-NS', name: '北區', country: 'SG' },
  { code: 'SG-NES', name: '東北區', country: 'SG' },
  
  // 美國各州
  { code: 'NY', name: '紐約州 (New York)', country: 'US' },
  { code: 'CA', name: '加利福尼亞州 (California)', country: 'US' },
  { code: 'TX', name: '德克薩斯州 (Texas)', country: 'US' },
  { code: 'FL', name: '佛羅里達州 (Florida)', country: 'US' },
  { code: 'IL', name: '伊利諾州 (Illinois)', country: 'US' },
  { code: 'PA', name: '賓夕法尼亞州 (Pennsylvania)', country: 'US' },
  { code: 'OH', name: '俄亥俄州 (Ohio)', country: 'US' },
  { code: 'GA', name: '喬治亞州 (Georgia)', country: 'US' },
  { code: 'NC', name: '北卡羅來納州 (North Carolina)', country: 'US' },
  { code: 'MI', name: '密西根州 (Michigan)', country: 'US' },
  { code: 'NJ', name: '紐澤西州 (New Jersey)', country: 'US' },
  { code: 'VA', name: '維吉尼亞州 (Virginia)', country: 'US' },
  { code: 'WA', name: '華盛頓州 (Washington)', country: 'US' },
  { code: 'MA', name: '麻薩諸塞州 (Massachusetts)', country: 'US' },
  { code: 'AZ', name: '亞利桑那州 (Arizona)', country: 'US' },
  { code: 'CO', name: '科羅拉多州 (Colorado)', country: 'US' },
  { code: 'CT', name: '康涅狄格州 (Connecticut)', country: 'US' },
  { code: 'DE', name: '德拉瓦州 (Delaware)', country: 'US' },
  { code: 'HI', name: '夏威夷州 (Hawaii)', country: 'US' },
  { code: 'ID', name: '愛達荷州 (Idaho)', country: 'US' },
  { code: 'IN', name: '印第安納州 (Indiana)', country: 'US' },
  { code: 'IA', name: '艾奧瓦州 (Iowa)', country: 'US' },
  { code: 'KS', name: '堪薩斯州 (Kansas)', country: 'US' },
  { code: 'KY', name: '肯塔基州 (Kentucky)', country: 'US' },
  { code: 'LA', name: '路易斯安那州 (Louisiana)', country: 'US' },
  
  // 加拿大各省
  { code: 'AB', name: '艾伯塔省 (Alberta)', country: 'CA' },
  { code: 'BC', name: '不列顛哥倫比亞省 (British Columbia)', country: 'CA' },
  { code: 'MB', name: '曼尼托巴省 (Manitoba)', country: 'CA' },
  { code: 'NB', name: '新布倫瑞克省 (New Brunswick)', country: 'CA' },
  { code: 'NL', name: '紐芬蘭與拉布拉多省 (Newfoundland and Labrador)', country: 'CA' },
  { code: 'NS', name: '新斯科舍省 (Nova Scotia)', country: 'CA' },
  { code: 'ON', name: '安大略省 (Ontario)', country: 'CA' },
  { code: 'PE', name: '愛德華王子島省 (Prince Edward Island)', country: 'CA' },
  { code: 'QC', name: '魁北克省 (Quebec)', country: 'CA' },
  { code: 'SK', name: '薩斯喀徹溫省 (Saskatchewan)', country: 'CA' },
  
  // 英國區域
  { code: 'GB-ENG', name: '英格蘭 (England)', country: 'GB' },
  { code: 'GB-SCT', name: '蘇格蘭 (Scotland)', country: 'GB' },
  { code: 'GB-WLS', name: '威爾斯 (Wales)', country: 'GB' },
  { code: 'GB-NIR', name: '北愛爾蘭 (Northern Ireland)', country: 'GB' },
  
  // 法國區域
  { code: 'FR-IDF', name: '法蘭西島大區 (Île-de-France)', country: 'FR' },
  { code: 'FR-ARA', name: '奧弗涅-羅訥-阿爾卑斯大區 (Auvergne-Rhône-Alpes)', country: 'FR' },
  { code: 'FR-HDF', name: '上法蘭西大區 (Hauts-de-France)', country: 'FR' },
  { code: 'FR-GES', name: '大東部大區 (Grand Est)', country: 'FR' },
  { code: 'FR-NAQ', name: '新阿基坦大區 (Nouvelle-Aquitaine)', country: 'FR' },
  
  // 德國聯邦州
  { code: 'DE-BW', name: '巴登-符騰堡州 (Baden-Württemberg)', country: 'DE' },
  { code: 'DE-BY', name: '巴伐利亞州 (Bayern)', country: 'DE' },
  { code: 'DE-BE', name: '柏林州 (Berlin)', country: 'DE' },
  { code: 'DE-BB', name: '勃蘭登堡州 (Brandenburg)', country: 'DE' },
  { code: 'DE-HB', name: '不來梅州 (Bremen)', country: 'DE' },
  
  // 澳洲各州領地
  { code: 'AU-NSW', name: '新南威爾士州 (New South Wales)', country: 'AU' },
  { code: 'AU-VIC', name: '維多利亞州 (Victoria)', country: 'AU' },
  { code: 'AU-QLD', name: '昆士蘭州 (Queensland)', country: 'AU' },
  { code: 'AU-WA', name: '西澳大利亞州 (Western Australia)', country: 'AU' },
  { code: 'AU-SA', name: '南澳大利亞州 (South Australia)', country: 'AU' },
  
  // 紐西蘭地區
  { code: 'NZ-AUK', name: '奧克蘭大區 (Auckland)', country: 'NZ' },
  { code: 'NZ-WGN', name: '惠靈頓大區 (Wellington)', country: 'NZ' },
  { code: 'NZ-CAN', name: '坎特伯雷大區 (Canterbury)', country: 'NZ' },
  { code: 'NZ-OTA', name: '奧塔哥大區 (Otago)', country: 'NZ' },
  { code: 'NZ-BOP', name: '豐盛灣大區 (Bay of Plenty)', country: 'NZ' },
];
